import Layout from '../components/Layout';
import ProfileComponent from '../components/Profile';

function Profile() {
  return (
    <Layout>
      <ProfileComponent />
    </Layout>
  );
}

export default Profile;
